import { brandPrimaryHoverTint, gray4, label, white } from '@Styles/colors';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../web/components-v2/Theme/theme';
import { BreakPoints } from '../../../../../../../web/styles/styles';

const { spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		padding: spacing.md,
		backgroundColor: white,
	},
	actionBar: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: `${spacing.md}px ${spacing.lg}px`,
		borderBottom: common.border,
	},
	filterSection: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: spacing.sm,
	},
	filterLabel: {
		fontSize: 14,
		fontWeight: 500,
		marginLeft: 0,
		whiteSpace: 'nowrap',
		alignSelf: 'center',
	},
	buttonGroup: {
		display: 'flex',
		alignItems: 'center',
		paddingRight: spacing.sm,
	},
	tableContainer: {
		maxHeight: '400px',
		overflowY: 'auto' as const,
		border: common.border,
		borderRadius: '4px',
	},
	tableOverrides: {
		width: '100%',
		tableLayout: 'fixed',
		minHeight: 'auto',
	},
	columnOverrides: {
		'& tr': {
			background: brandPrimaryHoverTint,
		},
	},
	autoCompleteDropdownContent: {
		maxHeight: 200,
		overflowY: 'auto',
	},
	autoCompleteDropdownItems: {
		padding: `${spacing.sm}px ${spacing.md}px`,
		cursor: 'pointer',
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.05)',
		},
	},
	userInput: {
		color: label,
		fontSize: 12,
		width: 200,
		[BreakPoints.forMinWidth(900)]: {
			width: 300,
		},
		[BreakPoints.forMinWidth(850)]: {
			[BreakPoints.forMaxWidth(900)]: {
				width: 250,
			},
		},
	},
	subtitle: {
		color: gray4,
		fontSize: 14,
		padding: `${spacing.md}px ${spacing.lg}px`,
		marginBottom: spacing.sm,
	},
	readOnlyText: {
		textAlign: 'left',
	},
});
